import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AreaTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { path } from '@bo-client/shared/constants/path';
import { DatesService } from '@bo-client/shared/dates/dates.service';
import { SearchSortDtoModel } from '@bo-client/shared/dynamic-search-serverside/dynamic-search.model';
import { AreaTypesModel } from '@bo-client/shared/models/areaTypes';
import { InstallerPassModel, InstallerStatusEnum } from '@bo-client/shared/models/installerPassDto';
import { UserDto } from '@bo-client/shared/models/userDto';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { TmUserListModalComponent } from '@bo-client/technician-management/tm-installer-pass/tm-installer-pass/tm-user-list-modal/tm-user-list-modal.component';
import { TmValidInstallerPassesModalComponent } from '@bo-client/technician-management/tm-installer-pass/tm-installer-pass/tm-valid-installer-passes-modal/tm-valid-installer-passes-modal.component';
import { InstallerPassStatusEnum } from '@bo-client/technician-management/tm-user/tm-user.model';

@Injectable({
  providedIn: 'root'
})
export class CommissioningManagementService {
  constructor(
    private router: Router,
    private datesService: DatesService,
    public matDialog: MatDialog,
    private dataShareService: DataShareService,
    private httpHapService: HttpHapService
  ) {}

  newCommissioning(idArea: number, areaList: AreaTypesModel[], passesList: InstallerPassModel[]) {
    const { name: area, description: areaDisplayName } = areaList.find(
      (areaModel) => areaModel.id === idArea
    );
    const validPassForThisAreaList = passesList.filter(
      (xPass) =>
        xPass.idarea == idArea &&
        xPass.status == InstallerStatusEnum.Valid &&
        !this.datesService.dateIsExpired(xPass.expirationdate)
    );

    if (validPassForThisAreaList.length > 1) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.id = 'valid-pass-list';
      dialogConfig.maxHeight = '70%';
      dialogConfig.width = '70%';
      dialogConfig.data = {
        areaDisplayName: areaDisplayName,
        areaTypeList: areaList,
        validPassesList: validPassForThisAreaList
      };
      const modalDialog = this.matDialog
        .open(TmValidInstallerPassesModalComponent, dialogConfig)
        .afterClosed()
        .subscribe((resOk) => {
          if (resOk) {
            this.navigateToCreateComissioning(area as AreaTypeEnum, resOk.pass.user.id, resOk.pass.id);
          }
        });
    } else {
      this.navigateToCreateComissioning(
        area as AreaTypeEnum,
        validPassForThisAreaList[0].user.id,
        validPassForThisAreaList[0].id
      );
    }
  }

  newCommissioningWithoutPass(area: AreaTypesModel, tmUserList: UserDto[]) {
    if (tmUserList.length > 1) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.id = 'user-list-for-areas-without-pass';
      dialogConfig.maxHeight = '70%';
      dialogConfig.width = '70%';
      dialogConfig.data = {
        areaDisplayName: area.description,
        tmUserList: tmUserList
      };
      const modalDialog = this.matDialog
        .open(TmUserListModalComponent, dialogConfig)
        .afterClosed()
        .subscribe((resOk) => {
          if (resOk) {
            this.navigateToCreateComissioning(area.name as AreaTypeEnum, resOk.user.id, null);
          }
        });
    } else {
      this.navigateToCreateComissioning(area.name as AreaTypeEnum, tmUserList[0].id, null);
    }
  }

  areaToPathParam(area: AreaTypeEnum) {
    return area.toString().toLowerCase();
  }

  getCommissioningsWithSearchModel(searchSortDto: SearchSortDtoModel, pageSize = 10) {
    return this.httpHapService.postTyped<{
      content: CommissioningRequestDtoModel[];
      totalElements: number;
    }>(searchSortDto, `/commissioningrequest/filter?page=0&size=${pageSize}`);
  }

  navigateToCreateComissioning(area: AreaTypeEnum, userId: number, passId: number) {
    this.router.navigate(
      [
        path.cmPrefix +
          '/' +
          path.cmCommissioningManagement +
          path.create +
          '/' +
          this.areaToPathParam(area) +
          '/' +
          passId
      ],
      { replaceUrl: false }
    );
  }

  navigateToEditCommissioning(area: AreaTypeEnum, commissioningId: number) {
    console.log('NAVIGATE TO EDIT', area, commissioningId);
    this.router.navigate(
      [path.cmPrefix + '/' + path.cmCommissioningManagement + path.edit + '/' + commissioningId],
      {
        replaceUrl: false
      }
    );
  }

  filterActiveAreas(listOfPasses: InstallerPassModel[]) {
    return listOfPasses.filter((pass) => {
      return !(
        (pass.idarea == 1 && this.dataShareService.tenantConfig.commissioning.gasConfig.deactivateProcess) ||
        (pass.idarea == 5 &&
          this.dataShareService.tenantConfig.commissioning.waterConfig.deactivateProcess) ||
        (pass.idarea == 2 && this.dataShareService.tenantConfig.commissioning.powerConfig.deactivateProcess)
      );
    });
  }

  filterAuthorisedPasses(currentUser: UserDto, listPasses: InstallerPassModel[]): InstallerPassModel[] {
    const filteredPassesList: InstallerPassModel[] = [];
    const authorisedAreas: AreaTypesModel[] = currentUser.areaTypes;
    listPasses.forEach((xPass) => {
      // THIS IS A HACKY WAY TO FILTER OUT THE DEACTIVATED AREAS - But since the whole construct needs to be refactored anyway we live with it
      // console.log('checking pass for validty', xPass);
      // if (
      //   (xPass.idarea == 1 &&
      //     this.dataShareService.tenantConfig.commissioning.gasConfig.deactivateProcess) ||
      //   (xPass.idarea == 5 &&
      //     this.dataShareService.tenantConfig.commissioning.waterConfig.deactivateProcess) ||
      //   (xPass.idarea == 2 &&
      //     this.dataShareService.tenantConfig.commissioning.powerConfig.deactivateProcess)
      // ) {
      //   console.log('Found pass for deactivated area', xPass);
      //   return;
      // }

      if (xPass.user.id == currentUser.id) {
        filteredPassesList.push(xPass);
      } else {
        const idxFoundArea = authorisedAreas.findIndex((xArea) => xArea.id == xPass.idarea);
        if (idxFoundArea != -1) {
          filteredPassesList.push(xPass);
        }
      }
    });
    return filteredPassesList;
  }

  hasValidPassByArea(currentUser: UserDto, areaType: AreaTypesModel): boolean {
    if (!currentUser.passes || currentUser.passes.length == 0) {
      return false;
    }
    let hasValidPass = false;
    currentUser.passes.forEach((x) => {
      // The id of the POWER area is 2 in Test and PROD
      if (
        x.idarea == areaType.id &&
        x.status == InstallerPassStatusEnum.Valid &&
        !this.datesService.dateIsExpired(x.expirationdate)
      ) {
        hasValidPass = true;
      }
    });
    return hasValidPass;
  }

  checkExpiredPasses(areaTypeList: AreaTypesModel[], listPasses: InstallerPassModel[]): any {
    const today: Date = new Date();
    const validPassList = [];
    const expiredPassList = [];

    areaTypeList.forEach((areaType) => {
      // Suchen Sie nach Pässen, die zu diesem Bereichstyp gehören und gültig sind
      const passesInArea = listPasses.filter(
        (pass) => pass.idarea === areaType.id && pass.status === InstallerPassStatusEnum.Valid
      );

      passesInArea.forEach((pass) => {
        if (this.datesService.dateIsExpired(pass.expirationdate)) {
          // Wenn das Ablaufdatum des Passes abgelaufen ist, fügen Sie ihn der Liste der abgelaufenen Pässe hinzu
          expiredPassList.push({
            id: pass.id,
            description: `${areaType.description}-Ausweis Nummer: ${pass.passNummer} ist abgelaufen`
          });
        } else {
          // Wenn der Pass noch gültig ist, fügen Sie ihn der Liste der gültigen Pässe hinzu
          if (!validPassList.some((item) => item.id === areaType.id)) {
            validPassList.push({
              id: areaType.id,
              name: areaType.name,
              description: areaType.description
            });
          }
        }
      });
    });

    return {
      validPassList: validPassList,
      expiredPassList: expiredPassList
    };
  }

  checkFeedbackRequestedPasses(listPasses: InstallerPassModel[]): InstallerPassModel[] {
    return listPasses
      .filter(
        (x) => x.status == InstallerStatusEnum.FeedbackNeeded && x.activities.filter((y) => y.information)
      )
      .map((x) => {
        return {
          ...x,
          comment: !!x.activities.length ? x.activities[x.activities.length - 1].information : ''
        };
      });
  }
}
